<template>
    <div class="ScorecardDashboardPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col">
                    <div class="paper">
                        <div class="tab-content">
                            <Scorecard />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    //import components
    import Scorecard from "./Scorecard.vue";


    export default {
        props: [],
        data: function () {
            return {
                PanesShown: "Scorecard"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            }
        },
        computed: {
            
        },
        components: {
            Scorecard
        }
    }
</script>

<style scoped>
</style>